import { React } from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';

import ProductEdit from 'pages/home/ribbon/components/controls/product-full/ProductEdit';
import { useCheckAllowEditProducts, useGetProductFullView } from 'hooks';
import selectorsGridView from 'common/components/grid-view/controllers/selectors';
import selectorUser from '@redux/user/selectors';

const EditProductOverlay = (props) => {
  const { productId, isProductFullView } = props;

  const { productFull } = useGetProductFullView({
    productId,
  });

  const itemsSelection = useSelector(
    selectorsGridView.makeSelectDetailCurrentITemsSelection()
  );

  const userInfo = useSelector(selectorUser.makeSelectUserInfo());

  const { checkAllowEditProductFull } = useCheckAllowEditProducts();

  const isAllowEditOverlay = checkAllowEditProductFull(productFull);

  const isDisabled = () => {
    if (isProductFullView) return !isAllowEditOverlay;

    if (!isProductFullView) {
      if (itemsSelection?.length !== 1) return true;

      if (!itemsSelection?.[0]?.isOverlayProduct) return true;

      const isSelectedBySourceMember =
        itemsSelection?.[0]?.sourceMemberId === userInfo?.companyId;

      if (!isSelectedBySourceMember) return true;
    }
  };

  const disabled = isDisabled();

  return (
    <Menu.Item
      key='edit-product'
      style={{
        backgroundColor: 'inherit',
      }}
      disabled={disabled}
    >
      <ProductEdit
        isDisabled={disabled}
        productId={productId}
        buttonText='Edit Product Overlay'
      />
    </Menu.Item>
  );
};

export default EditProductOverlay;
